import React from "react";
import Items from "./Component/Items/Items";
import Rightcounterbar from "./Component/RightBar/Rightcounterbar";

const totalItems = [
  {
    id: 1,
    name: "Asus Vivobook X515MA",
    stock: 20,
    qty: 1,
    price: 3,
    // price: 35500,
  },
  {
    id: 2,
    name: "Dell E1916HV 18.5 Inch",
    stock: 10,
    qty: 1,
    price: 10,
  },
  {
    id: 3,
    name: "Canon Eos 4000D 18MP",
    stock: 25,
    qty: 1,
    price: 5,
  },
];

const App = () => {
  // const data = useState((state) => state.shop.cartItems);
  return (
    <div className="bg-gray-50 h-full md:h-screen">
      <div className="grid place-items-center">
        <h1 className="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4">
          Shopping Cart
        </h1>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
          {totalItems &&
            totalItems.map((cardItem) => (
              <Items key={cardItem.id} cardItem={cardItem} />
            ))}
        </div>
        <Rightcounterbar />
      </div>
    </div>
  );
};

export default App;
